var map = {
	"./CommentCount.importable": [
		3215,
		331,
		53,
		215
	],
	"./DiscussionContainer.importable": [
		6916,
		331,
		53,
		760,
		611,
		916
	],
	"./EditionDropdown.importable": [
		6965,
		331,
		965
	],
	"./GetMatchStats.importable": [
		3639,
		331,
		53,
		639
	],
	"./InstagramBlockComponent.importable": [
		343,
		331,
		760,
		343
	],
	"./Links.importable": [
		588,
		331,
		53,
		924
	],
	"./MapEmbedBlockComponent.importable": [
		9641,
		331,
		760,
		641
	],
	"./MostViewedRightWrapper.importable": [
		5024,
		331,
		53,
		872,
		602
	],
	"./OnwardsLower.importable": [
		3213,
		331,
		53,
		872,
		213
	],
	"./OnwardsUpper.importable": [
		4999,
		331,
		53,
		872,
		999
	],
	"./RichLinkComponent.importable": [
		7051,
		331,
		53,
		51
	],
	"./SpotifyBlockComponent.importable": [
		9776,
		331,
		760,
		776
	],
	"./SubNav.importable": [
		6348,
		331,
		348
	],
	"./VineBlockComponent.importable": [
		8080,
		331,
		760,
		80
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8602;
module.exports = webpackAsyncContext;